import type { Action } from '@0xtorch/core'
import { createSolanaAddressId } from '../../utils'
import type { GeneratorParameters } from '../types'

export const generateFail = ({
  transaction,
  accountIds,
  source,
}: GeneratorParameters & { readonly source: string }):
  | readonly Action[]
  | undefined => {
  if (transaction.meta === null || transaction.meta.err === null) {
    return undefined
  }

  const signer = transaction.transaction.message.accountKeys[0].pubkey
  const accountIdSet = new Set(accountIds)
  if (!accountIdSet.has(createSolanaAddressId({ address: signer }))) {
    return undefined
  }

  return [
    {
      source,
      order: 0,
      type: 'fail-tx',
      evidence: 'system-rule',
      timestamp: transaction.blockTime * 1000,
      comment: undefined,
      app: undefined,
      transfers: [],
    },
  ]
}
